module.exports = {
	"dontseebutton": "I Don't See My Service Provider",
	"errormessage": "There was a problem verifying your account with your service provider. Please try again.",
	"noprovidermessage": "This service is only available throught participating service providers. Please check back soon to see if your service provider has been added.",
	"rememberedcancelbutton": "Not My Service Provider",
	"rememberedokbutton": "Continue",
	"successmessage": "You're now ready to watch.",
	"title": "Login",
	"viewallbutton": "View All Service Providers",
	"viewtopbutton": "Top Service Providers",
	"welcomemessage": "Get unlimited access to all your favorite content. It's free through your participating service provider and available on your favorite devices."
};


//////////////////
// WEBPACK FOOTER
// ./src/common/config/cvp-strings.json
// module id = 175
// module chunks = 1 2